// Copyright (c) 2019 Deere & Company

import '../../../styles/table.scss';
import { AgGridReact } from 'ag-grid-react';
import { PartGroupTwoTableColumnDefinitions } from '../ag-grid-definations/partGroup-2Column-defination';
import PropTypes from 'prop-types';
import React from 'react';


const rowSelection = 'single';

function onGridReady ( params ) {

    params.api.sizeColumnsToFit();

}

function onFunctionCodeSelect ( props, params ) {

    const selectedRows = params.api.getSelectedRows();
    let selectedRowsString = '';
    selectedRows.forEach( ( selectedRow, index ) => {

        if ( index !== 0 ) {

            selectedRowsString += ', ';

        }
        selectedRowsString = selectedRow;

    } );

    props.onFunctionCodeSelect( selectedRowsString );

}

function onFunctionCodeRowClick ( props, params ) {

    if ( params && params.data ) {

        props.onFunctionCodeSelect( params.data );

    }

}

const FCMTable = props => (
    <div>
        {props.productSeriesList.length > 0 && (
            <main>
                <section className="search-result-panel">
                    <div
                        className="ag-theme-balham ag-theme-popupbg"
                    >
                        <AgGridReact
                            columnDefs={PartGroupTwoTableColumnDefinitions}
                            rowData={props.productSeriesList}
                            onGridReady={onGridReady}
                            rowSelection={rowSelection}
                            onSelectionChanged={onFunctionCodeSelect.bind( this, props )}
                            onRowClicked={onFunctionCodeRowClick.bind( this, props )}
                            popupParent={document.body}
                        />
                    </div>
                </section>
            </main>
        )}
        <div>
            {props.productSeriesList.length === 0 && 'No Result Found'}
        </div>
    </div>
);

FCMTable.displayName = 'FCMTable';
FCMTable.propTypes = {
    productSeriesList: PropTypes.array.isRequired,
};

export default FCMTable;
